import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { StyledContainer, StyledHeader } from './JuniorsKit.styled';
import JuniorsKitAccordion from './JuniorsKitAccordion';
import JuniorsKitTabs from './JuniorsKitTabs';

type ContentProps = {
  content?: any[];
  links?: any[];
};

const JuniorsKit: React.FC<ContentProps> = ({ content, links }) => {
  const { t } = useI18n('helping-juniors');

  return (
    <StyledContainer>
      <StyledHeader>
        <Heading2 editorial>{t('helping-juniors.kit.title')}</Heading2>
      </StyledHeader>
      <JuniorsKitTabs content={content} links={links} />
      <JuniorsKitAccordion content={content} links={links} />
    </StyledContainer>
  );
};

export default JuniorsKit;
